import { Role } from '../../../typings/api';
import { AsyncStatus } from '../../types';

import actions from './actions';
import reducer from './reducer';
import selectors from './selectors';

export type EditingRoleState = Pick<Role, 'name' | 'description' | 'scope' | 'permissions' | 'isCustom'> & {
  id: number | 'add' | null;
  hasBeenEdited: boolean; // <- True if we are in a "dirty" state, used to display "unsaved changes" warning message.
};

export type RolesStore = {
  roles: {[key in number]: Role };
  status: AsyncStatus;
  editingRole: EditingRoleState | null; // This is the "active" role being edited on the add/edit roles page.
};

export default {
  actions,
  reducer,
  selectors,
};
